import React, { Component } from "react";

class SVGIcon extends Component {

  getSvg = (name) => {
    switch (name) {
      case "icon-close":
        return (
          <svg className="icon icon_new" viewBox="0 0 144 144" >
            <line id="close-2b810136-93de-4622-a0cc-fbdf15eb7667" x1="4" y1="4" x2="140" y2="140" strokeLinecap="round" strokeLinejoin="round"></line><line id="close-2d18ff19-f34e-4c5d-9791-2549bee849dd" x1="4" y1="140" x2="140" y2="4" strokeLinecap="round" strokeLinejoin="round"></line>
          </svg>
        );
      case "icon-chevron-down":
        return (
          <svg className="icon icon_new" viewBox="0 0 144 76">
            <polyline id="chevron-down-00134c7b-b10c-486b-af1b-ea0801b1e1c2" points="140 4 72 72 4 4" strokeLinecap="round" strokeLinejoin="round"></polyline>
          </svg>
        );
      case "icon-search":
        return (
          <svg className="icon icon_new" viewBox="0 0 160 160">
            <circle cx="60" cy="60" r="56" strokeLinecap="round" strokeLinejoin="round"></circle><line x1="99.6" y1="99.6" x2="156" y2="156" strokeLinecap="round" strokeLinejoin="round"></line>
          </svg>
        );
      case "icon-tick":
        return (
          <svg className="icon icon_new" viewBox="0 0 121.45 86.55">
            <polyline points="117.45 4 38.91 82.55 4 47.64" strokeLinecap="round" strokeLinejoin="round"></polyline>
          </svg>
        );
      case "icon-chevron-right":
        return (
          <svg className="icon icon_small icon_new" viewBox="0 0 76 144">
            <polyline id="chevron-right-2063ebf3-901a-4482-a254-6509fb6140e6" points="4 4 72 72 4 140" strokeLinecap="round" strokeLinejoin="round"></polyline>
          </svg>
        );
      case "icon-chevron-left":
        return (
          <svg className="icon icon_small icon_new" viewBox="0 0 76 144">
            <polyline id="chevron-left-a4e0e987-f44d-495f-8041-cbcac2454416" points="72 140 4 72 72 4" strokeLinecap="round" strokeLinejoin="round"></polyline>
          </svg>
        );
      case "icon-arrow-right":
        return (
          <svg className="icon icon_new icon_new" viewBox="0 0 100 100">
            <path d="M84.7549062,52 L10.4166667,52 C9.31209717,52 8.41666667,51.1045695 8.41666667,50 C8.41666667,48.8954305 9.31209717,48 10.4166667,48 L84.7549069,48 L72.7524531,35.9975462 C71.9714045,35.2164976 71.9714045,33.9501677 72.7524531,33.1691191 C73.5335017,32.3880705 74.7998316,32.3880705 75.5808802,33.1691191 L90.9975472,48.5857861 C91.7785958,49.3668347 91.7785958,50.6331646 90.9975472,51.4142132 L75.5808802,66.8308802 C74.7998316,67.6119288 73.5335017,67.6119288 72.7524531,66.8308802 C71.9714045,66.0498316 71.9714045,64.7835017 72.7524531,64.0024531 L84.7549062,52 Z"></path>
          </svg>
        );
      case "icon-add-or-plus":
        return (
          <svg className="icon icon_new" viewBox="0 0 112 112">
            <line id="add-or-plus-5296567e-a58a-41f4-935a-d538c044ff44" x1="108" y1="56" x2="4" y2="56" strokeLinecap="round" strokeMiterlimit="10"></line><line id="add-or-plus-1f1bac1e-c274-4b8a-9304-fc82bfd3afc9" x1="56" y1="4" x2="56" y2="108" strokeLinecap="round" strokeMiterlimit="10"></line>
          </svg>
        );
      case "icon-security":
        return (
          <svg className="icon" viewBox="0 0 128 160.85">
            <path d="M60,76V55.15a36,36,0,0,1,36-36h0a36,36,0,0,1,36,36V76" transform="translate(-32 -15.15)" strokeLinejoin="round" stroke="#e60000" strokeWidth="0.7em"></path><rect x="4" y="60.85" width="120" height="96" rx="24" ry="24" strokeLinecap="round" stroke="#e60000" fill="#e60000" strokeLinejoin="round"></rect><line id="security-69bf1ecc-76f3-4df6-ad3f-8ed90c2af041" x1="64" y1="84.85" x2="64" y2="132.85" strokeLinecap="round" stroke="#ffffff" strokeLinejoin="round"></line>
          </svg>
        );
      case "icon-circle-help":
        return (
          <svg focusable="false" aria-hidden="true" className="icon icon_new" viewBox="0 0 160 160">
            <circle cx="80" cy="80" r="76" strokeLinecap="round" strokeLinejoin="round"></circle><circle cx="80" cy="120" r="2" strokeLinecap="round" strokeLinejoin="round"></circle><circle cx="80" cy="120" r="1" strokeLinecap="round" strokeLinejoin="round"></circle><path d="M75.88,70.29S78.61,55.68,96,55.76s23.27,21.42,14.1,30.75C106,90.7,102.49,94.15,100,96.57a13.39,13.39,0,0,0-4,9.57v7.73" transform="translate(-16 -16)" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
        );
      case "icon-info-circle":
        return (
          <svg focusable="false" aria-hidden="true" className="icon icon_new" viewBox="0 0 160 160">
            <circle cx="80" cy="80" r="76" strokeLinecap="round" strokeLinejoin="round"></circle><circle cx="78" cy="45" r="2" strokeLinecap="round" strokeLinejoin="round"></circle><circle cx="78" cy="45" r="1" strokeLinecap="round" strokeLinejoin="round"></circle>
            <polyline points="80 114.5 80 68 72 68" strokeLinecap="round" strokeLinejoin="round"></polyline>
            <line x1="72" y1="116" x2="88" y2="116" strokeLinecap="round" strokeLinejoin="round"></line>
          </svg>
        );


      case "icon-warn-fill":
        return (
          <svg focusable="false" aria-hidden="true" viewBox="0 0 22 22" >
            <path id="prefix__a" d="M11 1.852c5.052 0 9.148 4.096 9.148 9.148S16.052 20.148 11 20.148 1.852 16.052 1.852 11 5.948 1.852 11 1.852zM11 14.3c-.425 0-.77.345-.77.77 0 .425.345.77.77.77.425 0 .77-.345.77-.77 0-.425-.345-.77-.77-.77zm0-8.36c-.365 0-.66.295-.66.66v5.5c0 .365.295.66.66.66.365 0 .66-.295.66-.66V6.6c0-.365-.295-.66-.66-.66z"></path>
          </svg>
        );
      case "icon-minus":
        return (
          <svg className="icon icon_new" viewBox="0 0 112 112">
            <line x1="108" y1="56" x2="4" y2="56" strokeLinecap="round" strokeMiterlimit="10"></line>
          </svg>
        );

      case "icon-call":
        return (
          <svg className="icon icon_small" viewBox="0 0 160 160">
            <path id="landline-or-call-f6e1c40a-76e9-4626-ab71-b616b443e8dd" data-name="<Pfad>" d="M115.81,129.17l12.85-9.7c3.39-1.74,6.88-2.16,9-.87,3.19,2,30,19.88,32.23,21.47s3.29,6.09.13,10.47S152.33,172.23,146.25,172s-31.39-1-78.61-48.47S20.13,51,20,45,37.62,24.88,42.1,21.84s9-1.86,10.59.31c1.77,2.47,19.22,29.17,21.14,32.23,1.31,2.09.79,5.56-1,8.88s-9.33,16-9.33,16S68.58,88.13,86,105.67C94.3,114.17,115.81,129.17,115.81,129.17Z" transform="translate(-16 -16)" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
        );

      case "icon-close-circle":
        return (
          <svg className="icon icon_new" viewBox="5 5 70 70">
            <path d="M39.6666667,6.4 C58.0393393,6.4 72.9333333,21.293994 72.9333333,39.6666667 C72.9333333,58.0393393 58.0393393,72.9333333 39.6666667,72.9333333 C21.293994,72.9333333 6.4,58.0393393 6.4,39.6666667 C6.4,21.293994 21.293994,6.4 39.6666667,6.4 Z M39.6666667,9.6 C23.0613052,9.6 9.6,23.0613052 9.6,39.6666667 C9.6,56.2720281 23.0613052,69.7333333 39.6666667,69.7333333 C56.2720281,69.7333333 69.7333333,56.2720281 69.7333333,39.6666667 C69.7333333,23.0613052 56.2720281,9.6 39.6666667,9.6 Z M28.9219938,28.4505892 C29.5468326,27.8257504 30.5598966,27.8257504 31.1847355,28.4505892 L31.1847355,28.4505892 L40,37.265 L48.8152645,28.4505892 C49.4033482,27.8625056 50.3353267,27.8279124 50.9638686,28.3468098 L51.0780062,28.4505892 C51.7028451,29.0754281 51.7028451,30.0884921 51.0780062,30.7133309 L51.0780062,30.7133309 L42.263,39.528 L51.0780064,48.3438602 C51.6660901,48.9319438 51.7006832,49.8639224 51.1817859,50.4924642 L51.0780064,50.6066019 C50.4531676,51.2314408 49.4401036,51.2314408 48.8152647,50.6066019 L48.8152647,50.6066019 L40,41.791 L31.1847353,50.6066019 C30.5966516,51.1946855 29.6646731,51.2292787 29.0361312,50.7103814 L28.9219936,50.6066019 C28.2971547,49.981763 28.2971547,48.9686991 28.9219936,48.3438602 L28.9219936,48.3438602 L37.736,39.528 L28.9219938,30.7133309 C28.3339101,30.1252473 28.299317,29.1932688 28.8182143,28.5647269 Z"></path>
          </svg>
        );

      case "icon-tick-circle":
        return (
          <svg className="icon icon_new" viewBox="0 0 68 68">
            <path d="M34,0.725 C52.3726727,0.725 67.2666667,15.618994 67.2666667,33.9916667 C67.2666667,52.3643393 52.3726727,67.2583333 34,67.2583333 C15.6273273,67.2583333 0.733333333,52.3643393 0.733333333,33.9916667 C0.733333333,15.618994 15.6273273,0.725 34,0.725 Z M34,3.925 C17.3946385,3.925 3.93333333,17.3863052 3.93333333,33.9916667 C3.93333333,50.5970281 17.3946385,64.0583333 34,64.0583333 C50.6053615,64.0583333 64.0666667,50.5970281 64.0666667,33.9916667 C64.0666667,17.3863052 50.6053615,3.925 34,3.925 Z M47.6104652,22.4686292 C48.235304,21.8437903 49.248368,21.8437903 49.8732069,22.4686292 C50.4980457,23.093468 50.4980457,24.106532 49.8732069,24.7313708 L49.8732069,24.7313708 L29.1440405,45.4605372 C28.5192016,46.0853761 27.5061376,46.0853761 26.8812988,45.4605372 L26.8812988,45.4605372 L17.6686292,36.2478676 C17.0437903,35.6230288 17.0437903,34.6099648 17.6686292,33.9851259 C18.293468,33.3602871 19.306532,33.3602871 19.9313708,33.9851259 L19.9313708,33.9851259 L28.0126696,42.0664247 Z"></path>
          </svg>
        );

      case "icon-refresh":
        return (
          <svg viewBox="0 0 16 14">
            <g fill="none" fillRule="evenodd">
              <path stroke="#4A4D4E" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M10.347 14.792c3.19-.004 5.773-2.593 5.77-5.783-.002-3.19-2.59-5.774-5.78-5.773-3.19.002-5.775 2.588-5.775 5.778v2.634" transform="translate(-1 -2)" />
              <path stroke="#4A4D4E" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M7.324 9L4.562 11.648 1.875 9" transform="translate(-1 -2)" />
              <path d="M0 0H18V18H0z" transform="translate(-1 -2)" />
            </g>
          </svg>
        );

        case "icon-error-circle":
        return (
          <svg viewBox="0 0 160 160" className="icon">
                <circle cx="80" cy="80" r="76" strokeLinecap="round" strokeLinejoin="round"></circle>
                <circle cx="80" cy="112" r="2" strokeLinecap="round" strokeLinejoin="round"></circle>
                <circle cx="80" cy="112" r="1" strokeLinecap="round" strokeLinejoin="round"></circle>
                <g id="error-circle-871f7280-711e-49d6-ace0-b94b312c953f">
                    <path id="error-circle-d947e1d8-e723-483f-a300-5dff55bbc330" d="M96,109.41"
                          transform="translate(-16 -16)" strokeLinecap="round" strokeLinejoin="round"></path>
                    <path id="error-circle-55dd8a7c-4efd-424c-81b3-5951f8846c99" d="M96,55.76"
                          transform="translate(-16 -16)" strokeLinecap="round" strokeLinejoin="round"></path>
                </g>
                <g id="error-circle-94a59eb1-2dac-4b51-86dd-50cd9792f528">
                    <line id="error-circle-e54ea458-eef3-436d-a760-c43c3089ee66" x1="80" y1="44" x2="80" y2="92.5"
                          strokeLinecap="round" strokeLinejoin="round"></line>
                </g>
          </svg>
        );

      default:
        return '';
    }
  };

  render() {
    return (
      <span className={this.props.className}>
        {this.getSvg(this.props.name)}
      </span>
    );
  }
}

export default SVGIcon;